import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  MenuItem,
  ListSubheader,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  Stack,
  ListItemText,
} from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import SettingsIcon from "@mui/icons-material/Settings";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteIcon from "@mui/icons-material/Delete";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import taxSettingsApi from "../api/taxSettingsApi";
import industryApi from "../api/industryApi";
import taxReportApi from "../api/taxReportApi";

import dayjs from "dayjs";
import "dayjs/locale/vi";
dayjs.locale("vi");

const revenues = [
  { value: -1, label: "Tự động" },
  { value: 1, label: "Doanh thu <= 500 triệu" },
  { value: 2, label: "500 triệu < Doanh thu <= 3 tỷ" },
  { value: 3, label: "3 tỷ < Doanh thu <= 50 tỷ" },
  { value: 4, label: "Doanh thu > 50 tỷ" },
];

const calculationMethod = [
  { value: 1, label: "Trực tiếp trên doanh thu" },
  //{ value: 2, label: "Khấu trừ" },
];

const pageNo = "TaxReportPage";

function TaxReportPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const customerInfor = useSelector((state) => state.auth.customerInfor);
  const roles = useSelector((state) => state.auth.roles) || null;
  const [tabValue, setTabValue] = useState(0);
  const [menuItems, setMenuItems] = useState([
    {
      stt: 0,
      text: "BC Hộ kinh doanh",
      path: "/bao-cao-thue/ho-kinh-doanh",
      pageNo: "SalesRevenueReportPage",
    },
    {
      stt: 1,
      text: "BC Công ty",
      path: "/bao-cao-thue/cong-ty",
      pageNo: "BusinessesPage",
    },
    // {
    //   stt: 2,
    //   text: "BC đối chiếu",
    //   path: "/bao-cao-thue/bao-cao-doi-chieu",
    //   pageNo: "InvoiceReconciliationReportPage",
    // },
    {
      stt: 3,
      text: "NGÀNH NGHỀ KINH DOANH",
      path: "/bao-cao-thue/nganh-nghe-kinh-doanh",
      pageNo: "IndustryChoicePage",
    },
    {
      stt: 4,
      text: "Cài đặt thuế",
      path: "/bao-cao-thue/cai-dat-thue",
      pageNo: "TaxSettingsPage",
    },
    {
      stt: 5,
      text: "Lưu trữ báo cáo",
      path: "/bao-cao-thue/luu-tru-bao-cao",
      pageNo: "StorageReportPage",
    },
    {
      stt: 6,
      text: "DANH MỤC NGÀNH NGHỀ",
      path: "/bao-cao-thue/danh-muc-nganh-nghe",
      pageNo: "IndustryPage",
    },
  ]);
  const [openTaxSetting, setOpenTaxSetting] = useState(false);
  const [openStorageReport, setOpenStorageReport] = useState(false);
  const [currentSetting, setCurrentSetting] = useState({
    taxCalculationMethod: null,
    revenueGroup: -1,
    determineCost: false,
    industryId: null,
  });
  const [revenueGroup, setRevenueGroup] = useState([]);
  const [businessType, setBusinessType] = useState([]);
  const [taxCalculation, setTaxCalculation] = useState([]);
  const [industries, setIndustries] = useState([]);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  // Tạo mảng năm từ 1900 đến năm hiện tại (đảo ngược để năm mới nhất lên đầu)
  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => 1900 + index,
  ).reverse();
  const getCurrentQuarter = () => Math.floor((new Date().getMonth() + 3) / 3);
  const [quarter, setQuarter] = useState(getCurrentQuarter());
  const quarters = [
    { value: -1, label: "Tất cả" },
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];

  const [filteredFiles, setFilteredFiles] = useState([]);
  const [selectYear, setSelectYear] = useState(currentYear);
  const [selectQuarter, setSelectQuarter] = useState(getCurrentQuarter());

  const fetchIndustries = async () => {
    try {
      const response = await industryApi.search("", 0, 100);
      if (response.success) {
        setIndustries(response.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    // const filtered = menuItems.filter((item) => {
    //   return roles.some(
    //     (x) =>
    //       x.PvNo === item.pageNo &&
    //       x.CtrNo === "viewPage" &&
    //       x.IsApproved === true,
    //   );
    // });
    const filtered = menuItems;
    setMenuItems(filtered);
    if (filtered.length > 0 && location.pathname.endsWith("/bao-cao-thue"))
      navigate(menuItems[tabValue].path);
  }, []);

  useEffect(() => {
    setTabValue(() => {
      let i = menuItems[0].stt;
      menuItems.map((item, index) => {
        if (
          location.pathname === item.path ||
          (item.path !== "/" && location.pathname.startsWith(item.path + "/"))
        )
          i = item.stt;
      });
      return i;
    });
  }, [location.pathname]);

  useEffect(() => {
    if (openTaxSetting) {
      async function getAllRevenueGroup() {
        try {
          const response = await taxSettingsApi.getAllRevenueGroup();
          if (response.success) {
            setRevenueGroup([
              { value: -1, label: "Tự động" },
              ...response.data.map((item) => ({
                value: item.groupId,
                label: item.groupName,
              })),
            ]);
          } else {
            toast.error(response.message);
          }
        } catch (error) {
          toast.error(error);
        }
      }
      async function getTaxCalculation(type) {
        try {
          const response = await taxSettingsApi.getTaxCalculation(type);
          if (response.success) {
            setTaxCalculation([
              ...response.data.map((item) => ({
                value: item.methodId,
                label: item.methodName,
              })),
            ]);
          } else {
            toast.error(response.message);
          }
        } catch (error) {
          toast.error(error);
        }
      }
      getAllRevenueGroup();
      getTaxCalculation(customerInfor?.customerBusinessTypeId);
      fetchIndustries();
    }
  }, [openTaxSetting]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleOpenTaxSetting = async (isOpen) => {
    try {
      if (isOpen) {
        const response = await taxSettingsApi.getTaxSetting(
          customerInfor?.CusId,
        );
        if (response.success) {
          if (response.data === null) {
            setCurrentSetting({
              taxCalculationMethod: null,
              revenueGroup: -1,
              determineCost: false,
            });
          } else setCurrentSetting(response.data);
        } else toast.error(response.message);
      } else {
        setCurrentSetting(null);
      }
      setOpenTaxSetting(isOpen);
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu:" + error);
    }
  };

  const handleSaveTaxSetting = async () => {
    try {
      const response = await taxSettingsApi.saveTaxSetting(
        customerInfor?.CusId,
        currentSetting.taxCalculationMethod,
        currentSetting.revenueGroup,
        currentSetting.determineCost,
        currentSetting.industryId,
      );
      if (response.success) {
        toast.success("Lưu thành công");
      } else toast.error(response.message);
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu: " + error);
    }
  };

  const handleOpenStorageReport = async (isOpen) => {
    try {
      if (isOpen) {
        fetchReports();
      } else {
        setCurrentSetting(null);
      }
      setOpenStorageReport(isOpen);
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu:" + error);
    }
  };
  const fetchReports = async () => {
    try {
      const response = await taxReportApi.GetReportFileByCustomer(
        customerInfor.CusId,
        -1,
        selectYear,
        selectQuarter,
      );
      if (response.success) {
        setFilteredFiles(response.data || []);
      } else toast.error(response.message);
    } catch (error) {
      toast.error(error);
      setFilteredFiles([]);
    }
  };
  const handleDownload = async (file) => {
    try {
      const response = await taxReportApi.DownloadFile(
        customerInfor.CusId,
        file.fileId,
      );
      const binaryData = response.data; // Lấy phần nội dung nhị phân

      if (
        !(binaryData instanceof Blob) &&
        !(binaryData instanceof ArrayBuffer)
      ) {
        toast.error("Lỗi xử lý dữ liệu!");
        console.error("Dữ liệu không phải nhị phân! Kiểm tra responseType.");
      }

      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error);
    }
  };
  const handleView = async (file) => {};

  const handleDelete = async (file) => {
    try {
      const response = await taxReportApi.DeleteFile(
        customerInfor.CusId,
        file.fileId,
      );
      if (response.success) fetchReports();
      else toast.error(response.message);
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <Grid>
      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          height: "calc(100vh - 140px)", // độ cao của Tabs/Header
          display: "flex",
          flexDirection: "column",
          overflow: "hidden", // PHẢI LÀ HIDDEN để trang con tự cuộn nội bộ
        }}
      >
        <Grid sx={{ display: "flex", alignItems: "center" }}>
          <Tabs
            value={tabValue}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            selectionFollowsFocus
          >
            {menuItems.map((item, index) => {
              return (
                <Tab
                  key={item.stt}
                  label={item.text}
                  value={item.stt}
                  onClick={() => {
                    navigate(item.path);
                  }}
                />
              );
            })}
          </Tabs>
          {/* <Grid sx={{ position: "fixed", right: 0 }}>
            <Tooltip title="Lưu trữ">
              <IconButton
                variant="contained"
                color="primary"
                size="large"
                onClick={() => handleOpenStorageReport(true)}
              >
                <Inventory2Icon fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Thiết lập">
              <IconButton
                variant="contained"
                color="primary"
                size="large"
                onClick={() => handleOpenTaxSetting(true)}
              >
                <SettingsIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </Grid> */}
        </Grid>
        {/* Menu Tabs */}

        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
          }}
        >
          {/*Route sẽ hiển thị trang con thông qua Outlet*/}
          <Outlet />
        </Box>
      </Box>
      <Dialog open={openTaxSetting} maxWidth="md" fullWidth>
        <DialogTitle>Thiết lập dữ liệu</DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <Typography variant="h6">Phương pháp tính thuế</Typography>
            <TextField
              select
              sx={{
                width: 400,
              }}
              size="small"
              value={currentSetting?.taxCalculationMethod ?? -1}
              onChange={(e) =>
                setCurrentSetting((prev) => ({
                  ...prev,
                  taxCalculationMethod:
                    e.target.value === -1 ? null : e.target.value,
                }))
              }
            >
              {taxCalculation.map((option) => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </TextField>
            <Typography variant="h6">Nhóm doanh thu</Typography>
            <ToggleButtonGroup
              value={currentSetting?.revenueGroup}
              exclusive // Chỉ cho phép chọn 1 (giống Radio)
              onChange={(e) => {
                setCurrentSetting((prev) => ({
                  ...prev,
                  revenueGroup: parseInt(e.target.value),
                }));
              }}
              color="primary"
              sx={{
                display: "flex",
                flexWrap: "wrap", // Tự động xuống dòng nếu quá dài
                gap: 2, // Khoảng cách giữa các nút (8px * 2 = 16px)
                border: "none", // Ẩn viền bao quanh group
                "& .MuiToggleButtonGroup-grouped": {
                  border: "1px solid #ccc !important", // Hiện lại viền cho từng nút
                  borderRadius: "8px !important", // Bo góc cho tất cả các nút
                  margin: 0, // Xóa margin mặc định
                },
              }}
            >
              {revenueGroup.map((item, index) => {
                return (
                  <ToggleButton value={item.value} key={item.value}>
                    {item.label}
                  </ToggleButton>
                );
              })}
            </ToggleButtonGroup>
            {/* <Grid
              container
              spacing={1}
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              {revenues.map((item, index) => {
                return (
                  <Button
                    variant="contained"
                    color="primary"
                    id={item.value}
                    sx={{ height: 100, width: 150 }}
                  >
                    {item.label}
                  </Button>
                );
              })}
            </Grid> */}

            <Typography variant="h6">
              Chi phí phục vụ sản xuất kinh doanh
            </Typography>
            <RadioGroup
              row
              value={currentSetting?.determineCost || false}
              onChange={(e) =>
                setCurrentSetting((prev) => ({
                  ...prev,
                  determineCost: e.target.value === "true" ? true : false,
                }))
              }
            >
              <FormControlLabel
                value="true"
                control={<Radio />}
                label="Xác định được"
              />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label="Không xác định"
              />
            </RadioGroup>
            <Typography variant="h6">Ngành nghề chính</Typography>
            <TextField
              margin="dense"
              select
              fullWidth
              label="Ngành nghề"
              value={currentSetting?.industryId || ""}
              onChange={(e) => {
                const selectedId = e.target.value;
                const selected = industries.find(
                  (x) => x.industryId === selectedId,
                );
                setCurrentSetting((prev) => ({
                  ...prev,
                  industryId: selectedId,
                  // industryVatRate: selected?.industryVatRate,
                  // industryPitRate: selected?.industryPitRate,
                }));
              }}
              size="small"
            >
              {/* Cách gom nhóm đơn giản nhất: dùng Set để lấy danh sách tên nhóm duy nhất */}
              {[...new Set(industries.map((i) => i.industryGroupName))].map(
                (group) => [
                  <ListSubheader
                    key={group}
                    sx={{ fontWeight: "bold", color: "black" }}
                  >
                    {group}
                  </ListSubheader>,
                  industries
                    .filter((item) => item.industryGroupName === group)
                    .map((option) => (
                      <MenuItem
                        key={option.industryId}
                        value={option.industryId}
                        sx={{ pl: 4 }}
                      >
                        {option.industryNameUi}
                      </MenuItem>
                    )),
                ],
              )}
            </TextField>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleSaveTaxSetting();
            }}
          >
            Lưu
          </Button>
          <Button
            variant="outlined"
            onClick={() => handleOpenTaxSetting(false)}
          >
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openStorageReport} maxWidth="md" fullWidth>
        <DialogTitle>Danh sách báo cáo</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, md: 3 }} sx={{ minWidth: 150 }}>
              <TextField
                select
                label="Năm"
                fullWidth
                value={selectYear}
                onChange={(e) => setSelectYear(e.target.value)}
                size="small"
                align="center"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 180,
                      },
                    },
                  },
                }}
              >
                {years.map((y) => (
                  <MenuItem key={y} value={y}>
                    {y}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} sx={{ minWidth: 150 }}>
              <TextField
                select
                label="Quý"
                fullWidth
                value={selectQuarter}
                onChange={(e) => setSelectQuarter(e.target.value)}
                size="small"
              >
                {quarters.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <Button
                variant="contained"
                onClick={fetchReports}
                fullWidth
                size="medium"
              >
                Tìm kiếm
              </Button>
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ mt: 2, minHeight: "300px" }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Danh sách báo cáo ({filteredFiles.length})
            </Typography>

            {filteredFiles.length > 0 ? (
              <List
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                  bgcolor: "background.paper",
                  maxHeight: 400,
                  overflow: "auto",
                }}
              >
                {filteredFiles.map((file, index) => (
                  <ListItem
                    key={index}
                    secondaryAction={
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Tải về">
                          <IconButton
                            edge="end"
                            color="primary"
                            onClick={() => handleDownload(file)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Xóa">
                          <IconButton
                            edge="end"
                            color="info"
                            onClick={() => handleDelete(file)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="Xem chi tiết">
                          <IconButton
                            edge="end"
                            color="info"
                            onClick={() => handleView(file)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip> */}
                      </Stack>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: "#f44336" }}>
                        <PictureAsPdfIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={file.fileName}
                      secondary={`Ngày tạo: ${dayjs(file.createdAt).format("DD/MM/YYYY HH:mm:ss")}`}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box sx={{ textAlign: "center", py: 5 }}>
                <Typography color="textSecondary">
                  Không tìm thấy báo cáo nào cho thời gian này.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => handleOpenStorageReport(false)}
          >
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default TaxReportPage;
